import moment from 'moment'
import { subMonths, formatDistanceStrict } from 'date-fns'
import { getUser } from '../storage/user'
import routeMapper from '../../components/routes/utils/route-mapper.json'
import { translate } from '../../../i18n/index'
import { useCategoryTitle } from '../../contexts/category-farm-context'
import { matchPath } from 'react-router'

const months = {
  Jan: 'Janeiro',
  Fev: 'Fevereiro',
  Mar: 'Março',
  Abr: 'Abril',
  Mai: 'Maio',
  Jun: 'Junho',
  Jul: 'Julho',
  Ago: 'Agosto',
  Set: 'Setembro',
  Out: 'Outubro',
  Nov: 'Novembro',
  Dez: 'Dezembro'
}

export function translateType(slug) {
  switch (slug) {
    case 'clinical_mastitis':
      return translate('labelMastiteClinicaGrumo')
    case 'subclinical_mastitis':
      return translate('labelMastiteSubclínica')
    case 'drying':
      return translate('labelSecagem')
    case 'post_treatment':
      return translate('labelPosTratamento')
    case 'post_calving':
      return translate('labelPosParto')

    default:
      return slug
  }
}

export function getTypeForSymbol(slug) {
  switch (slug) {
    case 'IMM':
      return translate('labelIntramamario')
    case 'AIN':
      return translate('labelAntiInflamatorio')
    case 'INJ':
      return translate('labelAntibioticoInjetavel')
    case 'SEL':
      return 'Selante'
    default:
      return slug
  }
}

export const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

export function getQuarter(diagnostic) {
  const quarters = []

  if (diagnostic.forequarterLeft && diagnostic.forequarterRight && diagnostic.hindquarterLeft && diagnostic.hindquarterRight) return 'CP'

  if (diagnostic.forequarterLeft) quarters.push(' AE')
  if (diagnostic.forequarterRight) quarters.push(' AD')
  if (diagnostic.hindquarterLeft) quarters.push(' PE')
  if (diagnostic.hindquarterRight) quarters.push(' PD')

  return quarters.join(' ')
}

export function brixBloodDiscriminatorColorString(value) {
  value = Number(value)
  if (value <= 0) return 'transparent'
  if (value <= 7) return '#eb5757'
  if (value >= 7 && value <= 8) return '#f2c94c'
  if (value >= 8 && value <= 9) return '#4cda73'
  if (value > 9) return '#00a32d'
}

export function cbtestDiscriminatorColorString(value) {
  value = Number(value)
  if (value === 0) return 'transparent'
  if (value < 50) return '#00a32d'
  if (value >= 50 && value <= 100) return '#f2c94c'
  if (value > 100 && value <= 299) return '#f2994a'
  if (value > 299) return '#eb5757'
}

export function brixDiscriminatorColorString(value) {
  value = Number(value)
  if (value <= 0) return 'transparent'
  if (value < 19) return '#eb5757'
  if (value === 19) return '#fe9900'
  if (value >= 20 && value <= 21) return '#fdcd00'
  if (value === 22) return '#8dd100'
  if (value > 22) return '#00bf11'
}

export function localeDateBrazil(date) {
  const dateAux = (new Date(date).toISOString())
  return moment(dateAux).subtract(3, 'hours')
}

export function dateFormat(date) {
  const dateAux = (new Date(date))
  return moment(dateAux)
}

export const getCustomDate = (date) => {
  const aux = new Date(date)
  return ('0' + aux.getUTCDate()).slice(-2) + '/' + ('0' + (aux.getUTCMonth() + 1)).slice(-2)
}

export const getCustomDateMontly = (date) => {
  const aux = new Date(date)
  return `${Object.keys(months)[aux.getMonth() - 1]}/${(aux.getUTCFullYear() + '').slice(-2)}`
}

export const getDate = (date) => {
  const newDate = new Date(date)
  return newDate
}

export const getMonth = (date) => {
  const dateAux = getDate(date)
  return dateAux.getUTCMonth()
}

export const subMonth = (quantity) => {
  return subMonths(new Date(), quantity)
}

export const formatDistanceStrictToNowInDays = (date) => {
  if (!date) return ''
  const date1 = new Date(date)
  return formatDistanceStrict(new Date(), date1, { unit: 'day' }).replace(/\D/g, '')
}

const formatDatetimePart = (value, part = '') => {
  if (part === 'month') {
    value++
  }
  return ('0' + value).slice(-2)
}

export const formatDateToString = (date) => {
  date = new Date(date)
  return `${date.getFullYear()}-${formatDatetimePart(date.getMonth(), 'month')}-${formatDatetimePart(date.getDate())}T${formatDatetimePart(date.getHours())}:${formatDatetimePart(date.getMinutes())}:${formatDatetimePart(date.getSeconds())}`
}

export function lockLink() {
  if (window.location.host.indexOf('.io') > -1) {
    return {
      cursor: 'not-allowed', background: '#e5e5e5', pointerEvent: 'none'
    }
  }
  return {}
}

export function verifyOrderCurrent(item) {
  switch (item) {
    case 'asc':
      return 'desc'
    case 'desc':
      return 'asc'
    default:
      return 'asc'
  }
}

export const priceFormat = (number) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(number)
}

export const getReportType = (slug) => {
  if (slug === 'consolidated_diagnostics_app') return 'Consolidado - Diagnósticos'
  if (slug === 'mastitis_cases_and_protocol_per_day_app') return 'Casos Mastite e tratamentos por dia'
  if (slug === 'consolidated_diagnostics_protocols_app') return 'Consolidado - diagnósticos, tratamentos e cura clínica'
  if (slug === 'ideagri_export_app') return 'Exportação - Ideagri'
  if (slug === 'acl_export_app') return 'Exportação - ACL'
  if (slug === 'consolidated_calf_app') return 'Consolidado'
  return null
}

export const getQuarterName = (item) => {
  let quarter = ''

  if (item.forequarterLeft) quarter = quarter + 'AE '
  if (item.forequarterRight) quarter = quarter + 'AD '
  if (item.hindquarterLeft) quarter = quarter + 'PE '
  if (item.hindquarterRight) quarter = quarter + 'PD '

  if (item.forequarterLeft && item.forequarterRight && item.hindquarterLeft && item.hindquarterRight) {
    quarter = 'CP'
  }

  return quarter
}

export const findProtocolInDiagnosticsProtocol = (diagnosticProtocols, protocol) => {
  return diagnosticProtocols?.find(item => item.protocol.id === protocol.id)
}

export const findProtocolInDiseaseProtocol = (diseaseProtocols, protocol) => {
  return diseaseProtocols?.find(item => item.protocol.id === protocol.id)
}

export const canShowUdderProtocol = (diagnostic, protocol) => {
  const diagnosticProtocolFound = findProtocolInDiagnosticsProtocol(diagnostic.diagnosticProtocols, protocol)
  if (!diagnosticProtocolFound) {
    return true
  }

  const openTasks = diagnostic.udderHealthTasks?.filter((task) => task.status === 'open' && task.protocol.id === protocol.id)
  if (openTasks.length === 0) {
    return true
  }

  return false
}

export const canShowCalfProtocol = (disease, protocol) => {
  const protocolFound = findProtocolInDiseaseProtocol(disease.diseaseProtocols, protocol)
  if (!protocolFound) {
    return true
  }

  const openTasks = disease.calfHealthTasks.filter((task) => task.status === 'open' && task.protocol.id === protocol.id)
  if (openTasks.length === 0) {
    return true
  }

  return false
}

export const canShowReprocess = (diagnostic) => {
  return diagnostic.type !== 'uncultured_mastitis'
}

export const handleBlockedButtons = (slug) => {
  const roles = getUser()?.roles
  return roles?.find((item) => item === slug)
}

export const allowedRoute = () => {
  let allowedRoute = true

  routeMapper.forEach((i) => {
    if (window.location.pathname.includes(i.rota)) {
      if (!getUser().roles.find((item) => {
        return item === i.slug
      })) {
        allowedRoute = false
      }
    }
  })

  return allowedRoute
}

export const isNegativeAgent = (agentName) => {
  return ['Negativo', 'NEGATIVO'].includes(agentName)
}

export const isUploadImageUrl = (url: string) => {
  return url.includes('upload_cb_test_original_plate_image') || url.includes('upload_plate_image') || url.includes('upload_diarrhea_image') || url.includes('upload_hemogram_image')
}

export const uploadImageErrorMessage = () => {
  return 'Houve um problema ao tentar processar esta imagem. Ela pode estar fora do padrão ideal. Por favor, troque a imagem.'
}

export function translateQuarter(slug) {
  switch (slug) {
    case 'PE':
      return translate('labelQuartoPE')
    case 'PD':
      return translate('labelQuartoPD')
    case 'AD':
      return translate('labelQuartoAD')
    case 'AE':
      return translate('labelQuartoAE')
    case 'CP':
      return 'CP'
    default:
      return slug
  }
}

export function findCategory(pathname) {
  const { categoryTitle } = useCategoryTitle()
  const titlePageCustom = categoryTitle?.title

  const categories = [
    {
      title: translate('btnFichaVaca'),
      route: '/',
      slug: '/ubere/ficha-da-vaca'
    },
    {
      title: `${titlePageCustom}`,
      route: '/ubere/ficha-da-vaca',
      slug: '/ubere/ficha-da-vaca/:id'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      route: '/',
      slug: '/ubere/analise-cbt-tanque'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      route: '/ubere/analise-cbt-tanque',
      slug: '/ubere/analise-cbt-tanque/:id'
    },
    {
      title: translate('labelAnaliseCbtTanque'),
      route: '/ubere-lancamento',
      slug: '/ubere/new-analise-cbt-tanque'
    },
    {
      title: translate('labelResultados'),
      route: '/',
      slug: '/ubere/resultados'
    },
    {
      title: translate('labelResultados'),
      route: '/ubere/resultados',
      slug: '/ubere/resultados/:id'
    },
    {
      title: 'Leitura da Placa',
      route: '/ubere/resultados',
      slug: '/ubere/leitura-de-resultados'
    },
    {
      title: 'Leitura da Placa',
      route: '/ubere/resultados',
      slug: '/ubere/leitura-de-resultados/:id'
    },
    {
      title: 'Lançamentos',
      route: '/',
      slug: '/ubere-lancamento'
    },
    {
      title: translate('labelRevisarLeituraAutomatica'),
      route: '/',
      slug: '/review-automatic-readings'
    },
    {
      title: translate('labelLancamentoMastiteLote'),
      route: '/',
      slug: '/mass-launches'
    },
    {
      title: 'Adicionar Tratamento',
      route: '/ubere/resultados',
      slug: '/ubere/adicionar-tratamento/:id'
    },
    {
      title: translate('btnExameMicrobiologico'),
      route: '/ubere-lancamento',
      slug: '/ubere/exame-microbiologico'
    },
    {
      title: translate('btnExameMicrobiologico'),
      route: '/ubere/resultados',
      slug: '/ubere/exame-microbiologico/:id'
    },
    {
      title: translate('labelNovaMastiteClinicaSemCultura'),
      route: '/ubere-lancamento',
      slug: '/ubere/nova-mastite-clinica-sem-exame'
    },
    {
      title: translate('labelNovaMastiteClinicaSemCultura'),
      route: '/ubere/resultados',
      slug: '/ubere/nova-mastite-clinica-sem-exame/:id'
    },
    {
      title: 'Reprocessar',
      route: '/ubere/resultados',
      slug: '/ubere/reprocessar/:id'
    },
    {
      title: 'Importação de dados',
      route: '/ubere/ficha-da-vaca',
      slug: '/ubere/importacao-de-dados'
    },
    {
      title: translate('labelTratamentos'),
      route: '/',
      slug: '/ubere/tratamentos'
    },
    {
      title: translate('labelTratamentos'),
      route: '/ubere/tratamentos',
      slug: '/ubere/tratamentos/:id'
    },
    {
      title: translate('labelTratamentos'),
      route: '/ubere/tratamentos',
      slug: '/ubere/tratamentos/compartilhar/:id'
    },
    {
      title: translate('labelNovoTratamento'),
      route: '/ubere/tratamentos',
      slug: '/ubere/novo-tratamento'
    },
    {
      title: translate('labelTarefas'),
      route: '/',
      slug: '/ubere/minhas-tarefas'
    },
    {
      title: `${titlePageCustom}`,
      route: '/ubere/minhas-tarefas',
      slug: '/ubere/tarefa/:id'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-intramamarios'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-injetaveis'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-anti-inflamatorios'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/top-5-intramamario-por-agentes'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/dias-tratamento-intramamario-por-agentes'
    },
    {
      title: translate('labelCuraClinica'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica'
    },
    {
      title: translate('labelCuraClinicaPorTratamento'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica-por-tratamento'
    },
    {
      title: translate('labelCuraClinicaDiagnóstico'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-cura-clinica-por-diagnostico'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/cura-clinica'
    },
    {
      title: 'OnFarms Benchmarking',
      route: '/ubere/comunidade-onfarmes',
      slug: '/ubere/incidencia-mastite-clinica'
    },
    {
      title: translate('labelGrafico'),
      route: '/',
      slug: '/ubere/graficos'
    },
    {
      title: translate('labelOcorrenciaMastiteClinica'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-ocorrencia-mastite-clinica'
    },
    {
      title: translate('labelIncidenciaMastiteClinica'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-incidencia-mastite-clinica'
    },
    {
      title: translate('labelFrequenciaCrescimento'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-frequencia-de-crescimento'
    },
    {
      title: translate('labelPrevalencaAgentes'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-prevalencia-de-agentes'
    },
    {
      title: translate('labelPrevalenciaGrupoGRAM'),
      route: '/ubere/graficos',
      slug: '/ubere/grafico-por-grupo-gram'
    },
    {
      title: 'Comunidade Onfarmers',
      route: '/',
      slug: '/ubere/comunidade-onfarmes'
    },
    {
      title: translate('labelDadosUsuario'),
      route: '/',
      slug: '/meus-dados/dados-do-usuario'
    },
    {
      title: 'Dados da fazenda',
      route: '/',
      slug: '/meus-dados/dados-da-fazenda'
    },
    {
      title: `${titlePageCustom}`,
      route: '/minhas-contas',
      slug: '/minhas-contas/:id'
    },
    {
      title: translate('labelMinhasContas'),
      route: '/',
      slug: '/minhas-contas'
    },
    {
      title: `${titlePageCustom}`,
      route: '/rastreio-de-pedidos',
      slug: '/rastreio-de-pedidos/:id'
    },
    {
      title: translate('labelRastreioPedidos'),
      route: '/',
      slug: '/rastreio-de-pedidos'
    },
    {
      title: 'Lactação',
      route: '/',
      slug: '/lactacao'
    },
    {
      title: 'Lactação',
      route: '/lactacao',
      slug: '/lactacao/:id'
    },
    {
      title: 'Nova Lactação',
      route: '/lactacao',
      slug: '/nova-lactacao'
    },
    {
      title: 'Relatórios',
      route: '/',
      slug: '/ubere/relatorios'
    },
    {
      title: translate('labelArtigosVideos'),
      route: '/',
      slug: '/artigos-e-videos'
    },
    {
      title: translate('labelArtigosVideos'),
      route: '/artigos-e-videos',
      slug: '/video'
    },
    {
      title: translate('labelArtigosVideos'),
      route: '/artigos-e-videos',
      slug: '/video/:id'
    },
    {
      title: translate('labelUsuarios'),
      route: '/',
      slug: '/usuarios'
    },
    {
      title: translate('labelUsuarios'),
      route: '/usuarios',
      slug: '/usuarios/:id'
    },
    {
      title: translate('labelNovoUsuario'),
      route: '/usuarios',
      slug: '/novo-usuario'
    },
    {
      title: translate('labelFazendas'),
      route: '/',
      slug: '/fazendas'
    },
    {
      title: translate('labelFazendas'),
      route: '/fazendas',
      slug: '/fazendas/:id'
    },
    {
      title: translate('labelNovaFazenda'),
      route: '/fazendas',
      slug: '/nova-fazenda'
    },
    {
      title: 'Token',
      route: '/',
      slug: '/token'
    },
    {
      title: translate('labelIntegracaoParceiros'),
      route: '/',
      slug: '/integracao-parceiros'
    },
    {
      title: translate('labelCentralNotificacao'),
      route: '/',
      slug: '/central-de-notificacoes'
    },
    {
      title: translate('labelRelatóriosProcessados'),
      route: '/ubere/relatorios',
      slug: '/ubere/relatorios-processados'
    },
    {
      title: translate('labelLeituraResultados'),
      route: '/ubere/resultados',
      slug: '/ubere/anexo-da-placa/:id'
    }
  ]

  return categories.filter((item) => matchPath(location.pathname, { path: item.slug, exact: true, strict: false }))
}
